module.exports = __webpack_public_path__ + "img/zhanshi.92a080a8.png";